import { render } from "./PageNavBar.vue?vue&type=template&id=90d87a62"
import script from "./PageNavBar.vue?vue&type=script&lang=js"
export * from "./PageNavBar.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\vue-workspace\\fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__